export function getCompanyChannelName(companyId) {
  return `private-company-${companyId}`;
}

export function getChatChannelName(chatId) {
  return `private-chat-${chatId}`;
}



// WEBPACK FOOTER //
// ./src/util/wsChannel.js